// Edit this file to update program content across the entire site.
import { img } from "framer-motion/client";
import {
  GiWeightLiftingUp,
  GiMuscleUp,
  GiRunningShoe,
  GiBodyBalance,
  GiHeartBeats,
  GiPunchBlast,
} from "react-icons/gi";

const programs = [
  {
    id: "strength-training",
    title: "Strength Training",
    icon: GiWeightLiftingUp,
    intensity: "High",
    img: "/gymimages/gym14.png",
    shortDescription:
      "Build raw power with progressive barbell and compound-lift programming designed around your current strength baseline.",
    overview:
      "Our strength track is built on compound movements — squat, deadlift, press and pull — progressed week over week so load increases only as your form allows.",
    focusAreas: [
      "Progressive overload",
      "Compound lifts",
      "Core stability",
      "Injury-aware form coaching",
    ],
    suitableFor:
      "Lifters who want measurable strength gains and are comfortable training 3–4 days a week.",
    sessionStructure: [
      { phase: "Warm-up", detail: "Joint mobility and activation, 10 minutes" },
      { phase: "Main lift", detail: "Heavy compound movement, 4–5 sets" },
      {
        phase: "Accessory work",
        detail: "Supporting muscle groups, 3 sets each",
      },
      { phase: "Cooldown", detail: "Guided stretching and breathing" },
    ],
    benefits: [
      "Increased functional strength",
      "Improved bone density",
      "Better posture and joint support",
    ],
  },
  {
    id: "functional-training",
    title: "Functional Training",
    icon: GiBodyBalance,
    intensity: "Medium",
    img: "/gymimages/gym10.jpg",
    shortDescription:
      "Movement-based conditioning that trains your body to handle real-world demands — carrying, climbing, bending, reacting.",
    overview:
      "Functional sessions combine kettlebells, sleds, bands and bodyweight patterns to build strength that transfers directly to daily life and sport.",
    focusAreas: [
      "Multi-planar movement",
      "Balance and coordination",
      "Grip and core strength",
    ],
    suitableFor:
      "Anyone who wants practical fitness — from first-time gym members to athletes in off-season.",
    sessionStructure: [
      { phase: "Activation", detail: "Dynamic mobility circuit" },
      { phase: "Movement blocks", detail: "3–4 stations, timed intervals" },
      { phase: "Finisher", detail: "Short conditioning burst" },
      { phase: "Recovery", detail: "Mobility and breathing" },
    ],
    benefits: [
      "Better everyday movement quality",
      "Reduced injury risk",
      "Improved coordination",
    ],
  },
  {
    id: "weight-management",
    title: "Weight Management",
    icon: GiHeartBeats,
    intensity: "Medium",
    img: "/gymimages/gym8.jpg",
    shortDescription:
      "A structured mix of resistance and metabolic conditioning paired with habit coaching to support sustainable fat loss.",
    overview:
      "This program pairs supervised training with simple, sustainable nutrition guidance so results last beyond the program itself.",
    focusAreas: [
      "Metabolic conditioning",
      "Resistance training",
      "Habit-based coaching",
      "Progress tracking",
    ],
    suitableFor:
      "Members focused on fat loss and building consistent, sustainable training habits.",
    sessionStructure: [
      { phase: "Warm-up", detail: "Light cardio and mobility" },
      { phase: "Circuit training", detail: "Resistance + cardio intervals" },
      { phase: "Core finisher", detail: "Targeted core work" },
      { phase: "Cooldown", detail: "Stretch and recovery" },
    ],
    benefits: [
      "Sustainable fat loss",
      "Improved energy levels",
      "Better long-term habits",
    ],
  },
  {
    id: "personal-training",
    title: "Personal Training",
    icon: GiMuscleUp,
    intensity: "Custom",
    img: "/gymimages/gym9.jpg",
    shortDescription:
      "One-on-one coaching with a program built entirely around your goals, schedule and starting point.",
    overview:
      "A dedicated trainer designs and adjusts your plan session to session, with close attention to form, recovery and progression.",
    focusAreas: [
      "Individual goal setting",
      "Custom periodisation",
      "Close form correction",
      "Flexible scheduling",
    ],
    suitableFor:
      "Members who want focused, individual attention and a fully customised plan.",
    sessionStructure: [
      { phase: "Assessment", detail: "Movement and goal review" },
      { phase: "Coached session", detail: "1-on-1 guided training" },
      { phase: "Progress check", detail: "Ongoing plan adjustment" },
    ],
    benefits: [
      "Faster, safer progress",
      "Full accountability",
      "Plan built around your life",
    ],
  },
  {
    id: "cardio-conditioning",
    title: "Cardio Conditioning",
    icon: GiRunningShoe,
    intensity: "High",
    img: "/gymimages/gym15.png",
    shortDescription:
      "High-output interval sessions built to raise your engine capacity and torch calories fast.",
    overview:
      "Interval-based cardio sessions on a mix of equipment and floor work, structured to keep heart rate in productive training zones.",
    focusAreas: [
      "Interval training",
      "Heart-rate zone work",
      "Endurance building",
    ],
    suitableFor:
      "Members chasing better stamina, endurance events, or a high-calorie-burn session.",
    sessionStructure: [
      { phase: "Warm-up", detail: "Progressive heart-rate build" },
      { phase: "Interval sets", detail: "Work-to-rest ratio training" },
      { phase: "Cooldown", detail: "Active recovery and stretch" },
    ],
    benefits: [
      "Improved cardiovascular health",
      "Higher calorie burn",
      "Better stamina",
    ],
  },
  {
    id: "muscle-building",
    title: "Muscle Building",
    icon: GiPunchBlast,
    intensity: "High",
    img: "/gymimages/gym5.jpg",
    shortDescription:
      "Hypertrophy-focused training with controlled tempo and volume to build size with good structure and symmetry.",
    overview:
      "Split-routine hypertrophy training with attention to tempo, time-under-tension and recovery between muscle groups.",
    focusAreas: [
      "Hypertrophy volume",
      "Tempo control",
      "Muscle-group splits",
      "Recovery planning",
    ],
    suitableFor:
      "Members focused on building visible muscle size with a structured, trackable plan.",
    sessionStructure: [
      { phase: "Warm-up", detail: "Target-muscle activation" },
      { phase: "Primary sets", detail: "4–5 sets, controlled tempo" },
      { phase: "Isolation work", detail: "Accessory movements, 3 sets" },
      { phase: "Cooldown", detail: "Stretch and recovery" },
    ],
    benefits: [
      "Visible muscle growth",
      "Improved symmetry",
      "Structured progression",
    ],
  },
];

export default programs;
